<template>
  <div class="camera-acquisition">
    <div class="flex-align-center" style="margin-bottom: 20px">
      <img
        src="@/assets/imgs/school/monthRecord/camera.png"
        alt=""
        style="width: 24px; height: 22px; margin-right: 5px"
      />
      <div class="record-title">相机采集数据</div>
    </div>
    <!--数据统计-->
    <div class="overview-list flex-between">
      <div class="overview-list-item">
        <div class="card-title">
          <div>本月情绪识别次数</div>
          <img src="@/assets/imgs/school/monthRecord/collectCircle.png" alt="" class="item-icon" />
        </div>
        <div style="transform: translateY(-15px)">
          <CountAnimation :end-val="cameraPartInfo.faceCount" class="count-bold" />
        </div>
      </div>
      <div class="overview-list-item">
        <div class="card-title">
          <div>学生抓拍覆盖率</div>
          <img src="@/assets/imgs/school/monthRecord/cameraCircle.png" alt="" class="item-icon" />
        </div>
        <div style="transform: translateY(-15px)">
          <div class="count-bold">
            <CountAnimation :end-val="Number(dataSource.coverageRate)" :attr="{ decimals: 2 }" />
            %
          </div>
          <div style="margin: 5px 0">
            已抓拍学生
            <span style="color: #fa6c3d; font-weight: bold">
              {{ dataSource.cameraStudentFaceCount }}
            </span>
            ｜ 人脸录入数
            <span style="color: #fa6c3d; font-weight: bold">{{ dataSource.studentFaceCount }}</span>
          </div>
        </div>
      </div>
      <div class="overview-list-item">
        <div class="card-title">
          <div>平均全校每日照片采集量</div>
          <img src="@/assets/imgs/school/monthRecord/pictureCircle.png" alt="" class="item-icon" />
        </div>
        <div style="transform: translateY(-15px)">
          <CountAnimation
            :end-val="cameraPartInfo.avgFaceCount"
            :attr="{ decimals: 2 }"
            class="count-bold"
          />
          张
        </div>
      </div>
      <div class="overview-list-item">
        <div class="card-title">
          <div>平均每生每日照片采集量</div>
          <img src="@/assets/imgs/school/monthRecord/figureBlue.png" alt="" class="item-icon" />
        </div>
        <div style="transform: translateY(-15px)">
          <CountAnimation
            :end-val="cameraPartInfo.avgStudentDayFaceCount"
            :attr="{ decimals: 2 }"
            class="count-bold"
          />
          张
        </div>
      </div>
      <div class="overview-list-item">
        <div class="card-title">
          <div>相机运行情况</div>
          <img src="@/assets/imgs/school/monthRecord/runCircle.png" alt="" class="item-icon" />
        </div>
        <div style="transform: translateY(-15px)">
          <span>
            在线
            <CountAnimation
              :end-val="cameraRunInfo.onlineCount"
              class="count-bold"
              style="color: #3fa3f5"
            />
            台
          </span>
          <span style="margin-left: 15px">
            离线
            <CountAnimation :end-val="cameraRunInfo.offlineCount" class="count-bold" />
            台
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CountAnimation from '@/components/CountAnimation'
import { queryOnlineAndOffline, queryAvgDayFaceOfStatusAndSchool } from '@/api/monthReport'

export default {
  name: 'CameraAcquisition',
  components: {
    CountAnimation,
  },
  props: {
    dateRange: {
      type: Object,
      default: () => ({}),
    },
    dataSource: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      cameraRunInfo: {
        onlineCount: 0,
        offlineCount: 0,
      },
      cameraPartInfo: {
        faceCount: 0,
        avgFaceCount: 0,
        avgStudentDayFaceCount: 0,
      },
    }
  },
  created() {
    this.queryOnlineAndOffline()
  },
  watch: {
    dateRange(dateObj) {
      const formatDateObj = {
        startTime: dateObj.beginDate,
        endTime: dateObj.endDate,
      }
      this.queryAvgDayFaceOfStatusAndSchool(formatDateObj)
    },
  },
  methods: {
    async queryOnlineAndOffline() {
      const { success, result } = await queryOnlineAndOffline()
      if (success) {
        this.cameraRunInfo = result
      }
    },
    async queryAvgDayFaceOfStatusAndSchool(formatDateObj) {
      const { success, result } = await queryAvgDayFaceOfStatusAndSchool(formatDateObj)
      if (success) {
        this.cameraPartInfo = result
      }
    },
  },
}
</script>
<style scoped lang="less">
.camera-acquisition {
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  .overview-list {
    .overview-list-item {
      box-sizing: border-box;
      width: 19%;
      height: 140px;
      padding: 16px;
      border: 1px solid #f3f4f6;
      border-radius: 10px;
      .card-title {
        display: flex;
        justify-content: space-between;
      }
      .count-bold {
        font-size: 30px;
        font-weight: bold;
      }
      .item-icon {
        width: 56px;
        height: 56px;
        border-radius: 50%;
      }
    }
  }
  .text-area {
    overflow: hidden;
    margin-top: 20px;
    border-radius: 11.75px;
    background-color: #fafcff;
    .header {
      box-sizing: border-box;
      height: 55px;
      padding-left: 20px;
      background: linear-gradient(130.74deg, rgba(23, 144, 255, 1) 0%, rgba(23, 144, 255, 0) 100%);
    }
  }
}
</style>
